module.exports = __webpack_public_path__ + "img/room-y1.fde56970.jpg";